var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialogComp',{ref:"dialog",attrs:{"zIndex":'10001'}},[_c('div',{staticClass:"question"},[_c('div',{staticClass:"question-title"},[_c('h3',[_vm._v("提交成功")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }